export const FeatureFlags = [
  {
    key: 'chat',
    description: 'Beneficiary can chat with the AI assistant but the organization loses access to tasks feature',
  },
  { key: 'emailAnalysis', description: 'Create note from forwarded email content' },
] as const
export type FeatureFlagName = (typeof FeatureFlags)[number]['key']

export type FeatureFlagOrganizationDTO = FeatureFlagName
